// extracted by mini-css-extract-plugin
export default {"container":"ProcessingModal_container__HrNZG","animation":"ProcessingModal_animation__lod-l","text":"ProcessingModal_text__1M8iF"};